import { render, staticRenderFns } from "./AccountNotifications.vue?vue&type=template&id=441b8d20&"
import script from "./AccountNotifications.vue?vue&type=script&lang=js&"
export * from "./AccountNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AccountNotifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports